/**
 * Returns the month-day string for ICD-10 code effective date filtering
 * @param useOctEffectiveDate - If true, returns October 1st date, otherwise January 1st
 * @returns Month-day string in format 'MM-DD'
 */
export function getIcd10MonthDay(useOctEffectiveDate?: boolean): string {
  return useOctEffectiveDate ? '10-01' : '01-01';
}
